import {
    DragDropContext,
    Droppable,
    OnDragEndResponder,
} from "@hello-pangea/dnd";
import {
    Box,
} from "@mui/material";
import { DraggableListProps } from "./types";
import { useStyles } from "./styles";
import { DraggableItemComponent } from "../draggableItem";
import { useCatalogStore } from "../../context";


export const DraggableList = ({ items, depth, parentId = null, rootId, level }: DraggableListProps) => {

    const styles = useStyles()


    const { moveItem } = useCatalogStore();

    const handleDragEnd: OnDragEndResponder = (result) => {
        if (!result.destination) return;
        const reordered = Array.from(items ?? []);
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);
        moveItem(parentId, reordered);
    };

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable-list">
                {(provided) => (
                    <Box
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        sx={styles.container(!parentId,depth % 2 === 0, level === 1)}
                    >
                        {items?.map((item, index) => (
                            <DraggableItemComponent
                                children={item.children}
                                key={item.id}
                                index={index}
                                item={item}
                                depth={depth}
                                rootId={rootId}
                                parentId={parentId}
                                level={level}
                            />
                        ))}
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </DragDropContext>
    );
};
